export const VALIDATION_REQUEST_INTERVAL = 60000;
